<template>
  <div class="list-page-sidebar">

    <slot name="beforeFilters" />

    <PageSection font="medium">
      <SectionBox>
        <BasicSection appearance="sidebar">
          <div class="list-page-sidebar__filters">
            <slot name="filters" />
          </div>
        </BasicSection>
      </SectionBox>
    </PageSection>

  </div>
</template>

<script>
  import SectionBox from "src/components/SectionBox/SectionBox.vue";
  import BasicSection from "src/components/sections/BasicSection/BasicSection.vue";
  import PageSection from "src/components/sections/PageSection/PageSection.vue";

  export default {
    name: 'ListPageSidebar',
    components: { PageSection, BasicSection, SectionBox },
  }
</script>